<template>
    <b-form-row>
        <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="this.id" :title="title">
            <ConsultarRequisicoes :onlyAproved='onlyAproved' :prefix="updatedPrefix"
                @onDblClickRequisicao="requisicaoSelect" />
        </b-modal>

        <lg-form-input-finder v-if="!modalOnly" :value="computedValue" @input="updateValue"
            fieldDescription="numeroRequisicaoCompra" :label="label" invalidFeedback="Requisição deve ser informada!"
            description="" @handleClean="handleClean" :error="error" :cols="cols" :disabled="disabled">
            <template #prepend>
                <b-button :disabled="disabled" @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import ConsultarRequisicoes from "@/modules/compra/requisicao-compra/ConsultarRequisicoes.vue"

export default {
    components: { LgFormInputFinder, ConsultarRequisicoes },
    props: {
        onlyAproved: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        id: String,
        prefix: {
            type: Array,
            default: () => [],
        },
        value: Object,
        cols: String,
        label: String,
        error: {
            type: Object,
            default: null,
        },
        modalOnly: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            internalValue: this.value || {},
        }
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.internalValue
            },
            set(newValue) {
                this.internalValue = newValue
            },
        },
        updatedPrefix() {
            return [...this.prefix, "Requisição"]
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
    },
    methods: {
        show() {
            this.$bvModal.show(this.id)
        },
        updateValue(newValue) {
            this.computedValue = newValue
            this.$emit("input", newValue)
        },
        handleClean() {
            this.computedValue = {}
            this.$emit("input", {})
        },
        requisicaoSelect(item) {
            this.computedValue = item
            this.$emit("input", item)
            this.$bvModal.hide(this.id)
        },
    },
}
</script>
